<template>
	<!-- Add Config Modal -->
		<div class="modal fade show" id="modal-default" tabindex="-1" style="display: block;" aria-modal="true">
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Add Category</h5><i class="modal-close zwicon-close pull-right display-4" @click='close'></i>
					</div> 
					<div class="modal-body">
						<table id="data-table" class="table dataTable no-footer" role="grid" aria-describedby="data-table_info">
                            <tbody class="table-dark">
                                <tr role="row">
                                    <th colspan="1"><label for="temp-item-serialno">Category Name</label></th>
                                    <td colspan="3"> 
                                        <div class="form-group mb-0">
                                            <input id="temp-item-serialno" class="form-control" v-model='temp_item_serial_no'>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
					</div>
					<ErrorMessage :message='error' v-if='error.length > 0' />
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" @click='action'><i class="zwicon-plus"></i> Add Category</button>
                    </div>
				</div>
			</div>
		</div>
		<!-- End Add Item Modal -->
</template>

<script>
	import PermissionService from "@/common/permission.service";

    import { mapGetters } from "vuex";
	import ErrorMessage from "@/components/General/ErrorMessage";
    import store from "@/store";

	import { ADD_CATEGORY_ENTRY } from "@/store/actions.type";

	export default {
		name: 'AddCategory',
		components: {
			ErrorMessage
		},
		props: {
            item: {},
        },
		data(){
			return {
				error: '',
				user: {
					name: '',
					email: '',
					role: ''
				},

                temp_item_category: '',
                temp_item_description: '',
                temp_item_serial_no: '',
                temp_item_size: '',
                temp_item_pinn_conn: '',
                temp_item_box_conn: '',
                temp_item_SP: '',
                temp_item_RW: '',
                temp_item_dirty: '',
                temp_item_comments: '',

				errors: {
					name: '',
					email: '',
					role: ''
				}
			};
		},
        mounted(){
            this.temp_item = this.item;
            
        },
        computed: {
            new_item(){
                return {
                    'name': this.temp_item_serial_no
                }
            },
            filtered_description_list(){
                if([null, false, ''].includes(this.temp_item_category)) return [];
                return this.description_list.filter(x => x.parent_id == this.temp_item_category);
            }, 
            ...mapGetters(['inventory_list', 'user', 'loading', 'size_list', 'category_list', 'connector_list', 'description_list'])
        },
		methods: {
			getPermission(category, permission){
				return PermissionService.getPermission(category, permission);
			},
			get_error(key){
				if(this.errors[key] !== undefined) return this.errors[key];
				return '';
			},
			close(){
				this.$emit('close');
			},
			action(){
				store.dispatch(ADD_CATEGORY_ENTRY, this.new_item).then(() => {
                    
                    this.$emit('added',this.new_item);
				}).catch(message => {
					console.log(message);
				}).finally(() => {
					
				});
                
				
			},
		}
	}
</script>